import React, { useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap'
import './Slider.css'
import axios from 'axios'

function Slider() {
    const [images, setImages] = useState([])

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_ENDPOINT}fetch_home`)
           .then((res) => {
            console.log('FULL RESPONSE:', res)
            console.log('DATA:', res.data)
           if (Array.isArray(res.data)) {
            setImages(res.data)
           } else if (Array.isArray(res.data.data)) {
            setImages(res.data.data)
           } else {
            console.log('Unexpected format:', res.data)
            setImages([])
           }
            })		 
            .catch((err) => {
                console.error('fetch_home error:', err)
                setImages([])
            })
    }, [])

    return (
        <Carousel fade controls={false} indicators={false} interval={3000}>
            {images.map((im) => {
                return (
                    <Carousel.Item key={im.id}>
                        <img src={im.portrait_url} alt={im.id} />
                        <Carousel.Caption>
                            <h3>{im.name}</h3>
                        </Carousel.Caption>
                    </Carousel.Item>
                )
            })}
        </Carousel>
    )
}

export default Slider
